module.exports = __webpack_public_path__ + "static/media/pajero-1982na.4d6e1a99.jpg";